const shrimpRouter = [
    {
        path: "list-shrimp",
        name: "shrimp",
        component: () => import("@/views/admin/shrimp"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-shrimp/add",
        name: "addShrimp",
        component: () => import("@/views/admin/shrimp/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-shrimp/edit/:id",
        name: "editShrimp",
        component: () => import("@/views/admin/shrimp/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default shrimpRouter;